import * as React from "react";
import {Card} from "react-bootstrap";
import {isMobile} from "react-device-detect";

interface CommonCardLayoutProps {
    children: React.ReactNode;
    isSmallScreenSize: boolean;
}

export const CommonCardLayout: React.FC<CommonCardLayoutProps> = ({ children, isSmallScreenSize }) => (
    <Card
        className={`add-to-cart-card ${isSmallScreenSize || isMobile ? 'fixed-bottom m-0 border-0 border-top' : ''}`}>
        <Card.Body className="pt-2">
            {children}
        </Card.Body>
    </Card>
);